var _Rect, _Path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { Rect, Path } from "react-native-svg";
function SvgStart(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }, props), _Rect || (_Rect = /*#__PURE__*/React.createElement(Rect, {
    width: 31,
    height: 31,
    x: 0.5,
    y: 0.5,
    stroke: "#E1087E",
    rx: 15.5
  })), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    fill: "#E1087E",
    d: "M15 18.5l-5.925-.75c-.417-.05-.688-.275-.813-.675s-.037-.742.263-1.025l10.225-9.8a.797.797 0 01.3-.188c.117-.041.275-.062.475-.062.333 0 .588.142.763.425.174.283.179.575.012.875L17 13.5l5.925.75c.417.05.688.275.813.675s.037.742-.263 1.025l-10.225 9.8a.797.797 0 01-.3.188 1.454 1.454 0 01-.475.062.844.844 0 01-.762-.425c-.175-.283-.18-.575-.013-.875l3.3-6.2z"
  })));
}
export default SvgStart;